import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Documento } from '../../../models/payment-notices-response';
import {SubscriptionManager} from "../../../shared/subscription-manager/subscription-manager.class";
import {FormBuilder, Validators} from "@angular/forms";
import {AlertService} from "../../../shared/alert/alert.service";
import { AmministrazioneService } from '../../../services/amministrazione.service';
import {RatingService} from "../../../services/rating.service";
import {take} from "rxjs";
import {ConfigurazioneGeneraleService} from "../../../services/configurazione-generale.service";
import {UserData} from "../../../models/user-data";
import { PnFunzioneServizio } from '../../../models/servizio';
import {AccountService} from "../../../core/auth/account.service";
import {PaymentnoticesService} from "../../../services/paymentnotices.service";

@Component({
  selector: 'jhi-pagamento-terminato',
  templateUrl: './pagamento-terminato.component.html',
  styleUrls: ['./pagamento-terminato.component.scss']
})
export class PagamentoTerminatoComponent  extends SubscriptionManager implements OnInit {
  statoPagamento: string;
  idServizioAmm!: string;
  feedbackInviato = false;
  selectedRating = 0;
  questionText = '';
  choices: string[] = [];
  inTextAreaPhase = false;
  circleLoading = false;
  cdTributo: string = '';
  numeroTributo: number;
  userData!: UserData;
  listaPagamenti: Array<Documento>;
  tributo: Documento | null;
  funzioneServizio!: PnFunzioneServizio;

  ratingForm = this.fb.group({
    valutazione: [this.fb.control<number | null>(null), Validators.required],
    primaRisposta: [this.fb.control<number | null>(null)],
    secondaRisposta: [this.fb.control<number | null>(null)],
    pnServizio: this.fb.group({
      id: ['', Validators.required]
    }),
    note: [''],
  })

  constructor( protected paymentNoticesService: PaymentnoticesService, private accountService: AccountService, private activatedRoute: ActivatedRoute, protected confService: ConfigurazioneGeneraleService,private fb: FormBuilder, private router: Router, private route: ActivatedRoute,private ratingService: RatingService,private ammService: AmministrazioneService, private alertService: AlertService) {
    super();
    this.statoPagamento = "";
    this.listaPagamenti = [];
    this.tributo = null;
    this.numeroTributo=0;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.statoPagamento = <string>params['status'];
      this.cdTributo = <string>params['cdTributo'];
    });
    this.numeroTributo = this.activatedRoute.snapshot.params["numero"];

    this.subs.sink = this.ratingForm.controls['valutazione'].valueChanges.subscribe({
           next: () =>{
             this.ratingService.selectedChoiceIndex = -1;
             this.ratingForm.patchValue({
               primaRisposta: null,
               secondaRisposta: null,
             })
           }
         });


    this.ammService.getIdByNmServizio("Pagamenti").pipe(take(1)).subscribe({
           next: (res) => {
             this.idServizioAmm = res;
             this.ratingForm.patchValue({
               pnServizio: {
                 id: this.idServizioAmm,
               }
             })
           }
         })

    this.subs.sink = this.ammService.pnFunzioneServizioByCdFunzione(this.cdTributo).subscribe({
      next: (res) => {
        this.funzioneServizio = res;
      }
    })
    this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}');
    if(this.userData?.cf){
      this.richiestaPosizioniTributarie();
    }else{
      this.accountService.loggedSubject.subscribe(() => {
        this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}');
        this.richiestaPosizioniTributarie();
      })
    }
  }
  initPaymentNotices(): any{
      return {
        codiceFiscale: <string> this.userData.cf,
        codiceTributo: this.cdTributo
      }
  }

  richiestaPosizioniTributarie():void{
    this.circleLoading = true;
    this.paymentNoticesService.getPaymentNotices(this.initPaymentNotices()).subscribe({
        next: (res) => {
          this.listaPagamenti = res.mandatiPagamento;
          this.tributo = this.listaPagamenti.find(pg => pg.Numero == this.numeroTributo) || null;
          this.circleLoading = false;
        },
        error: (err) => {
          this.circleLoading = false;
          if(err && err.error && err.error.detail){
            this.alertService.creaAlert(err.error.detail, "danger", "sticky", 5000, true)
          }else{
            this.alertService.creaAlert("Errore nel pagamento", "danger", "sticky", 5000, true)
          }
      }
    })
  }


  goToServizi():void{
    window.location.href = this.confService.configurazione.linkServizi;
  }

  goToPagareTributi():void{
    window.location.href = this.confService.configurazione.linkServizi;
  }

  submitQuestion(): void {
    this.circleLoading = true;
    this.subs.sink = this.ratingService.salvaFeedback(this.ratingForm.value).subscribe({
      error: (err) => {
        this.feedbackInviato = false;
        this.circleLoading = false;
        this.alertService.creaAlert(err.error.messaggio, 'danger', "sticky", 5000, true);
      },
      complete: () => {
        this.feedbackInviato = true;
        this.circleLoading = false;
        this.alertService.creaAlert('Feedback inviato con successo.', "success", "sticky", 5000, true);
      }
    });
  }

  onRatingSelected(rating: number): void {
      this.selectedRating = rating;
      this.ratingForm.get('valutazione')?.setValue(rating)
      if (this.selectedRating <= 3) {
        this.questionText = "Dove hai incontrato le maggiori difficoltà?";
        this.choices = ["A volte le indicazioni non erano chiare", "A volte le indicazioni non erano complete", "A volte non capivo se stavo procedendo correttamente", "Ho avuto problemi tecnici", "Altro"];
      } else {
        this.questionText = "Quali sono stati gli aspetti che hai preferito?";
        this.choices = ["Le indicazioni erano chiare", "Le indicazioni erano complete", "Capivo sempre che stavo procedendo correttamente", "Non ho avuto problemi tecnici", "Altro"];
      }
      this.inTextAreaPhase = false;
    }

  resetSelection(): void {
    this.ratingService.resetArray(); // Resetta l'array delle stelle tramite il servizio
    this.ratingForm.get('valutazione')?.setValue(null)
    this.selectedRating = 0;
    this.questionText = '';
    this.choices = [];
  }

  handleChoiceSelected(selectedIndex: number): void {
    if(this.selectedRating < 4){
      this.ratingForm.patchValue({
        primaRisposta: null,
        secondaRisposta: selectedIndex,
      });
    }else{
      this.ratingForm.patchValue({
        primaRisposta: selectedIndex,
        secondaRisposta: null,
      })
    }
  }

  backToChoices(): void {
    if (this.inTextAreaPhase) {
      this.inTextAreaPhase = false;
    }
  }

  showTextArea(): void {
    this.inTextAreaPhase = true; // Abilita la fase del campo di testo libero
  }
}
